import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import type { EntityWatcherModel } from '../interfaces';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { UserEntity } from './user.entity';

/**
 * Entity for tracking users who are watching a client.
 * Used by the notification system to send activity updates.
 */
@Index('client_user__fk_user__id_fk', ['fkUserId'], {})
@Index('client_user_pk', ['fkClientId', 'fkUserId'], { unique: true })
@Entity('client_user')
export class ClientUserEntity extends BaseEntity implements EntityWatcherModel {
	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity | null;

	@ManyToOne(() => ClientEntity, (client) => client.clientUsers, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;
}
